import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Input,
  Label,
} from "@repo/ui";
import { useState } from "react";

import { useDbTestCreate, useDbTestDelete, useDbTestList } from "@/lib/queries/use-db-test";

export default function DbTestPage() {
  const { data, isLoading, error } = useDbTestList();
  const createMut = useDbTestCreate();
  const deleteMut = useDbTestDelete();
  const [name, setName] = useState("");
  const [dueDate, setDueDate] = useState<string>("");

  return (
    <div className="container mx-auto max-w-2xl py-10">
      <Card>
        <CardHeader>
          <CardTitle>Database Test</CardTitle>
          <CardDescription>Create and list items from the database.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <form
            className="space-y-3"
            onSubmit={async (e) => {
              e.preventDefault();
              if (!name.trim()) return;
              await createMut.mutateAsync({ name: name.trim(), dueDate: dueDate || null });
              setName("");
              setDueDate("");
            }}
          >
            <div className="grid gap-2">
              <Label htmlFor="name">Name</Label>
              <Input
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="e.g. Hello DB"
              />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="dueDate">Due date</Label>
              <Input
                id="dueDate"
                type="date"
                value={dueDate}
                onChange={(e) => setDueDate(e.target.value)}
              />
            </div>
            <Button type="submit" disabled={createMut.isPending}>
              {createMut.isPending ? "Saving..." : "Add Item"}
            </Button>
          </form>

          <div className="border-t pt-4">
            {isLoading ? (
              <p className="text-muted-foreground">Loading...</p>
            ) : error ? (
              <p className="text-destructive">Failed to load.</p>
            ) : !data || data.length === 0 ? (
              <p className="text-muted-foreground">No items yet.</p>
            ) : (
              <ul className="space-y-2">
                {data.map((item) => (
                  <li
                    key={item.id}
                    className="flex items-center justify-between rounded-md border p-3"
                  >
                    <div>
                      <p className="font-medium">{item.name}</p>
                      <p className="text-xs text-muted-foreground">
                        #{item.id} • {new Date(item.createdAt).toLocaleString()}
                        {item.dueDate
                          ? ` • Due: ${new Date(item.dueDate).toLocaleDateString()}`
                          : ""}
                      </p>
                    </div>
                    <Button
                      variant="destructive"
                      size="sm"
                      disabled={deleteMut.isPending}
                      onClick={() => deleteMut.mutate(item.id)}
                    >
                      Delete
                    </Button>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
